import { render, staticRenderFns } from "./ProductsTable.vue?vue&type=template&id=b21be248&scoped=true"
import script from "./ProductsTable.vue?vue&type=script&lang=js"
export * from "./ProductsTable.vue?vue&type=script&lang=js"
import style0 from "./ProductsTable.vue?vue&type=style&index=0&id=b21be248&prod&scoped=true&lang=css"
import style1 from "./ProductsTable.vue?vue&type=style&index=1&id=b21be248&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21be248",
  null
  
)

export default component.exports